import * as tslib_1 from "tslib";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var CourseDataService = /** @class */ (function () {
    function CourseDataService(httpService) {
        this.httpService = httpService;
    }
    /**
     * Parse the response from Kentico's response into a more standard JS Object
     * @param item The item from Kentico
     * @param modularContent The Modular Content from Kentico response
     */
    CourseDataService.mapKenticoObject = function (item, modularContent) {
        var newObj = {};
        newObj.system_id = item.system.id;
        newObj.system_type = item.system.type;
        newObj.system_name = item.system.name;
        newObj.system_codename = item.system.codename;
        newObj.system_last_modified = item.system.last_modified;
        Object.keys(item.elements).forEach(function (k) {
            if (!item.elements[k]) {
                newObj[k] = null;
            }
            else if (item.elements[k].type === 'modular_content') {
                newObj[k] = item.elements[k].value.map(function (modK) {
                    if (modularContent && modularContent[modK]) {
                        return CourseDataService.mapKenticoObject(modularContent[modK], modularContent);
                    }
                    else {
                        return modK;
                    }
                });
            }
            else if (Array.isArray(item.elements[k].value) && item.elements[k].type === 'asset') {
                newObj[k] = item.elements[k].value;
            }
            else {
                // TODO handle multiple_choice
                // TODO do we need name?
                //TODO is useful or does ngrx handle this for me?
                if (k.endsWith('_date') && typeof item.elements[k].value === 'string') {
                    try {
                        var newDate = new Date(item.elements[k].value);
                        if (newDate instanceof Date && !isNaN(newDate)) {
                            newObj[k] = newDate;
                            return;
                        }
                    }
                    catch (e) {
                        console.log("unable to parse " + k + " (" + item.elements[k].value + " to date");
                    }
                }
                newObj[k] = item.elements[k].value;
            }
        });
        return newObj;
    };
    CourseDataService.getRequestOptions = function () {
        return { params: new HttpParams(), headers: new HttpHeaders().append('Authorization', "Bearer " + environment.kenticoToken) };
    };
    CourseDataService.prototype.getCourse = function (itemId) {
        if (environment.production) {
            return this.httpService.get(environment.kenticoRoot + "/item-" + itemId + ".json").pipe(map(function (r) { return new Course(r); }));
        }
        else {
            var options = CourseDataService.getRequestOptions();
            options.params = options.params.append('system.type', 'course');
            return this.httpService.get(environment.kenticoRoot + "/items/" + itemId, options).pipe(map(function (r) { return environment.production ? r : CourseDataService.mapKenticoObject(r.item, r.modular_content); }), map(function (r) { return new Course(r); }));
        }
    };
    CourseDataService.prototype.getCourses = function () {
        if (environment.production) {
            return this.httpService.get(environment.kenticoRoot + "/items.json").pipe(map(function (res) { return res.map(function (r) { return new Course(r); }); }));
        }
        else {
            var options = CourseDataService.getRequestOptions();
            options.params = options.params
                .append('system.type', 'course')
                .append('depth', '3');
            return this.httpService.get(environment.kenticoRoot + "/items", options).pipe(map(function (r) { return environment.production ? r : r.items.map(function (i) { return CourseDataService.mapKenticoObject(i, r.modular_content); }); }), map(function (res) { return res.map(function (r) { return new Course(r); }); }));
        }
    };
    CourseDataService.prototype.getPageHome = function () {
        return this.httpService.get(environment.kenticoRoot + "/items.json").pipe(map(function (r) { return new PageHome(r); }));
    };
    CourseDataService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CourseDataService_Factory() { return new CourseDataService(i0.ɵɵinject(i1.HttpClient)); }, token: CourseDataService, providedIn: "root" });
    return CourseDataService;
}());
export { CourseDataService };
var KenticoObject = /** @class */ (function () {
    function KenticoObject() {
    }
    return KenticoObject;
}());
export { KenticoObject };
var KenticoAsset = /** @class */ (function () {
    function KenticoAsset(data) {
        Object.assign(this, data);
    }
    return KenticoAsset;
}());
export { KenticoAsset };
var Course = /** @class */ (function (_super) {
    tslib_1.__extends(Course, _super);
    function Course(data) {
        var _this = _super.call(this) || this;
        Object.assign(_this, data);
        _this.banner = (data.banner && data.banner.length) ? new KenticoAsset(data.banner[0]) : null;
        _this.catalog_image = (data.catalog_image && data.catalog_image.length) ? new KenticoAsset(data.catalog_image[0]) : null;
        _this.study_guide = (data.study_guide && data.study_guide.length) ? new KenticoAsset(data.study_guide[0]) : null;
        _this.instructors = (data.instructors || []).map(function (i) { return new Instructor(i); });
        _this.lectures = (data.lectures || []).map(function (i) { return new CourseLecture(i); });
        _this.publication_date = data.publication_date ? new Date(data.publication_date) : null;
        return _this;
    }
    return Course;
}(KenticoObject));
export { Course };
var Instructor = /** @class */ (function (_super) {
    tslib_1.__extends(Instructor, _super);
    function Instructor(data) {
        var _this = _super.call(this) || this;
        Object.assign(_this, data);
        _this.profile_photo = (data.profile_photo && data.profile_photo.length) ? new KenticoAsset(data.profile_photo[0]) : null;
        return _this;
    }
    return Instructor;
}(KenticoObject));
export { Instructor };
var CourseContent = /** @class */ (function (_super) {
    tslib_1.__extends(CourseContent, _super);
    function CourseContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CourseContent;
}(KenticoObject));
export { CourseContent };
var CourseLecture = /** @class */ (function (_super) {
    tslib_1.__extends(CourseLecture, _super);
    function CourseLecture(data) {
        var _this = _super.call(this) || this;
        Object.assign(_this, data);
        _this.study_guide = (data.study_guide && data.study_guide.length) ? new KenticoAsset(data.study_guide[0]) : null;
        _this.recommended_readings = (data.recommended_readings || []).map(function (rr) { return new KenticoAsset(rr); });
        _this.instructors = (data.instructors || []).map(function (i) { return new Instructor(i); });
        _this.supplementary_videos = (data.supplementary_videos || []).map(function (i) { return new SupplementalVideo(i); });
        return _this;
    }
    return CourseLecture;
}(CourseContent));
export { CourseLecture };
var SupplementalVideo = /** @class */ (function (_super) {
    tslib_1.__extends(SupplementalVideo, _super);
    function SupplementalVideo(data) {
        var _this = _super.call(this) || this;
        Object.assign(_this, data);
        return _this;
    }
    return SupplementalVideo;
}(CourseContent));
export { SupplementalVideo };
var PageHome = /** @class */ (function (_super) {
    tslib_1.__extends(PageHome, _super);
    function PageHome(data) {
        var _this = _super.call(this) || this;
        Object.assign(_this, data);
        _this.banner_background = (data.banner_background && data.banner_background.length) ? new KenticoAsset(data.banner_background[0]) : null;
        return _this;
    }
    return PageHome;
}(KenticoObject));
export { PageHome };
